export default function EventContent({
  content,
}) {
  return (
    <div className="prose lg:prose-lg">
      <div dangerouslySetInnerHTML={{ __html: content }} />
    </div>
  );
}
